// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../config/styles';

const styles = ({
  mainContainer: {
    display: 'flex',
    minHeight: 'calc(100vh - 270px)',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  text: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_GREY,
  },
  boldText: {
    fontFamily: `${GlobalStyles.fonts.FONT_ANLTP_BOLD} !important`
  },
  descriptionContainer: {
    margin: '10px 30px',
  },
  mapExampleImage: {
    margin: '0 30px',
    maxWidth: '100%',
  },
  mapContainer: {
    width: '100%',
    margin: 10,
    minHeight: 300,
  },
  postcodeContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
  },
  completeButton: {
    margin: '10px auto 0 auto',
  },
  link: {
    color: GlobalStyles.color.COLOR_SECONDARY,
    '&:hover': {
      textDecoration: 'none',
      color: GlobalStyles.color.COLOR_SECONDARY,
    }
  }
});

export default styles;
